import type { ReactNode } from "react";
import { PageHeader, pageMain } from "../ui";
import { SiteLayout } from "./SiteLayout";
interface ContentPageProps {
	title: string;
	subtitle?: string;
	children: ReactNode;
	prose?: boolean;
	actions?: ReactNode;
}
export function ContentPage({ title, subtitle, children, prose = true, actions }: ContentPageProps) {
	return (
		<SiteLayout>
			<main id="main-content" className={`mx-auto w-full max-w-3xl flex-1 px-4 sm:px-6 ${pageMain}`}>
				<PageHeader title={title} description={subtitle} actions={actions} />
				<div className={prose ? "prose-gsplat" : undefined}>{children}</div>
			</main>
		</SiteLayout>
	);
}
